import React from "react";
import "../../App.css";
import { Gamepad2, ChevronRight, CalendarPlus, ChartNoAxesCombined } from "lucide-react";
import { SidebarMenuItem, SidebarMenuButton, SidebarMenuSub, SidebarMenuSubButton, SidebarMenuSubItem } from "../ui/sidebar";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "../../components/ui/collapsible";
import { Link, useLocation } from "react-router-dom";

const LinkDrop = ({ Icon, pageKey, page, activeMenu, setActiveMenu, accessibleSubpages = [] }) => {
  const location = useLocation();
  const subpages = page.subpages;

  // Check if specific pages are accessible
  const hasAccessToPlanning = accessibleSubpages.includes("Planning");
  const hasAccessToStatistics = accessibleSubpages.includes("Statistics");

  // If no subpages or no access to any subpages, don't show dropdown arrow
  const showDropdown = subpages && (hasAccessToPlanning || Object.keys(subpages).some((key) => accessibleSubpages.includes(key)));

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isOpen = activeMenu === pageKey;

  return (
    <Collapsible open={isOpen} onOpenChange={() => setActiveMenu(isOpen ? null : pageKey)} key={pageKey} className="group/collapsible">
      <SidebarMenuItem>
        <CollapsibleTrigger asChild>
          <SidebarMenuButton className={`hover:!text-white hover:!bg-accent/70 text-black justify-apart ${isActive(`/${pageKey}`) ? "bg-accent" : ""}`}>
            {Icon ? <img src={Icon} alt={`${pageKey} icon`} className="size-5" /> : <Gamepad2 className="size-6 stroke-black dark:stroke-white" />}
            <span className={isActive(`/${pageKey}`) ? "text-white" : "text-[var(--text-dark)] dark:text-[var(--text-light)]"}>{pageKey}</span>
            {showDropdown && (
              <ChevronRight
                className={`ml-auto size-4 transition-transform ${isOpen ? "rotate-90" : ""} ${isActive(`/${pageKey}`) ? "stroke-white" : "stroke-[var(--text-dark)] dark:stroke-[var(--text-light)]"}`}
              />
            )}
          </SidebarMenuButton>
        </CollapsibleTrigger>
        {showDropdown && (
          <CollapsibleContent>
            <SidebarMenuSub>
              {/* Only show Planning if user has access to it */}
              {hasAccessToPlanning && (
                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild>
                    <Link to={`/${pageKey}`} className={`hover:!bg-accent/30 appearance-none no-underline ${isActive(`/${pageKey}`) ? "bg-accent/50 text-white" : ""}`}>
                      <CalendarPlus className="size-3" />
                      <span className="text-sm">Planning</span>
                    </Link>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              )}

              {/* Only show Statistics if user has access to it */}

              {hasAccessToStatistics && (
                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild>
                    <Link to={`/${pageKey}/Statistics`} className={`hover:!bg-accent/30 appearance-none no-underline ${isActive(`/${pageKey}/Statistics`) ? "bg-accent/50 text-white" : ""}`}>
                      <ChartNoAxesCombined className="size-3" />
                      <span className="text-sm">Statistics</span>
                    </Link>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              )}
            </SidebarMenuSub>
          </CollapsibleContent>
        )}
      </SidebarMenuItem>
    </Collapsible>
  );
};

export default LinkDrop;
